import { render, staticRenderFns } from "./BaseFieldInput.vue?vue&type=template&id=242dfc68"
import script from "./BaseFieldInput.vue?vue&type=script&lang=js"
export * from "./BaseFieldInput.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldInput.vue?vue&type=style&index=0&id=242dfc68&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports